import { render, staticRenderFns } from "./ui-image.vue?vue&type=template&id=abee1616"
import script from "./ui-image.vue?vue&type=script&lang=js"
export * from "./ui-image.vue?vue&type=script&lang=js"
import style0 from "./ui-image.vue?vue&type=style&index=0&id=abee1616&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports